<template>
   <div class="test-form">
      <Modal 
         :show="show" 
         :loading="loading" 
         :icon="PumpAttendant.forms.add_pump_attendant.icon" 
         :title="PumpAttendant.forms.add_pump_attendant.title" 
         :subtitle="PumpAttendant.forms.add_pump_attendant.subtitle" 
         @close="$store.commit('show',false)"
         @submit="addAttendant({ref: $refs[PumpAttendant.forms.add_pump_attendant.name]})"
      >
         <template slot="form">
            <Form 
               classBinding="row" 
               :ref="PumpAttendant.forms.add_pump_attendant.name" 
               :forms="PumpAttendant.forms.add_pump_attendant.forms" 
               :formData="PumpAttendant.forms.add_pump_attendant.data"
            />
         </template>
      </Modal>

      <Modal 
         :show="showEdit" 
         :loading="loading" 
         :icon="PumpAttendant.forms.edit_pump_attendant.icon" 
         :title="PumpAttendant.forms.edit_pump_attendant.title" 
         :subtitle="PumpAttendant.forms.edit_pump_attendant.subtitle" 
         @close="$store.commit('showEdit',false)"
         @submit="editPumpAttendant({ref: $refs[PumpAttendant.forms.edit_pump_attendant.name]})"
      >
         <template slot="form">
            <Form 
               classBinding="row" 
               :ref="PumpAttendant.forms.edit_pump_attendant.name" 
               :forms="PumpAttendant.forms.edit_pump_attendant.forms" 
               :formData="PumpAttendant.forms.edit_pump_attendant.data"
            />
         </template>
      </Modal>

      <Modal 
         :show="showUpload" 
         :loading="loading" 
         :icon="PumpAttendant.forms.upload_pump_attendant.icon" 
         :title="PumpAttendant.forms.upload_pump_attendant.title" 
         :subtitle="PumpAttendant.forms.upload_pump_attendant.subtitle"
         button="Upload" 
         @close="$store.commit('show',false)"
         @submit="uploadPumpAttendants({ref: $refs[PumpAttendant.forms.upload_pump_attendant.name]})"
      >
         <template slot="form">
            <Form 
               classBinding="row" 
               :ref="PumpAttendant.forms.upload_pump_attendant.name" 
               :forms="PumpAttendant.forms.upload_pump_attendant.forms" 
               :formData="PumpAttendant.forms.upload_pump_attendant.data"
            />
         </template>
      </Modal>

      <Table 
         :icon="PumpAttendant.tables.attendants.icon" 
         :table_fields="PumpAttendant.tables.attendants.table_fields" 
         :table_data="attendants" 
         :title="PumpAttendant.tables.attendants.title" 
         :search_fields="PumpAttendant.tables.attendants.search_fields"
         :row_data="PumpAttendant.tables.attendants.row_data"
         @on-action="handleActions"
      />

      <div class="row justify-content-end" v-if="attendants.length > 0">
         <div class="col-12 col-md-4 col-lg-3">
            <div class="btn btn-long btn-primary mt-3" @click="downloadExcel()">Download Report</div>
         </div>
      </div>
   </div>
</template>

<script>
import attendant from "../rsc/stores/configs/pumpAttendants.store";
const XLSX = require('xlsx')

export default {
   beforeDestroy () {
      this.$store.unregisterModule('attendant')
   },
   created(){
      EventBus.$emit('loader:show',true)
      utils.registerModule('attendant',attendant,this.$store)

      setTimeout(() => {
         EventBus.$emit('actions:register',{
            title: 'Pump Attendant Actions',
            actions: [
               {
                  title: 'Upload Pump Attendants',
                  icon: 'fa-upload',
                  event: 'action:upload_pump_attendant',
               },
               {
                  title: 'Add Pump Attendant',
                  icon: 'fa-users',
                  event: 'action:add_pump_attendant',
               },
            ]
         })
      },200);

      EventBus.$on("action:add_pump_attendant", payload => {
         this.$store.commit('show', true)
      });
      EventBus.$on("action:upload_pump_attendant", payload => {
         this.$store.commit('showUpload', true)
      });
   },
   components:{
      Modal: () => import("@/libs/clarks/components/modal"),
      Form: () => import("@/libs/clarks/components/form"),
      Table: () => import("@/libs/clarks/components/table/table"),
   },
   computed: {
      ...mapGetters([
         'PumpAttendant',
         'attendants',
         'show',
         'showEdit',
         'selectedAttendant',
         'loading',
         'showUpload',
      ])
   },
   methods: {
      ...mapActions([
         'addAttendant',
         'editPumpAttendant',
         'deletePumpAttendant',
         'fetchAttendants',
         'fetchFormData',
         'uploadPumpAttendants',
      ]),
      async handleActions(payload){
         if(payload.action === 'attendant:delete'){
            await this.deletePumpAttendant(payload.row._id)
         }else if(payload.action === 'attendant:edit'){
            let Model = this.PumpAttendant
            Model.forms.edit_pump_attendant.data = payload.row
            console.log(Model.forms)
            this.$store.commit('PumpAttendant',Model)
            this.$store.commit('selectedAttendant',payload.row)
            this.$store.commit('showEdit',true)
         }
      },
      downloadExcel(){
         try{
            let data = []
            for(let i=0;i<this.attendants.length;i++){
               let attendant = this.attendants[i]

               data.push({
                  'COUNT': i+1,
                  'ID NUMBER': attendant.idNumber.toString(),
                  'ATTENDANT NAME': attendant.csaName,
                  'DEALER NAME': attendant.dealerName,
                  'STATION': attendant.station,
                  'MOBILE NUMBER': attendant.mobileNumber,
                  'PROMO CODE': attendant.promoCode,
               })
            }

            let workSheet = XLSX.utils.json_to_sheet(data);
            let wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, workSheet, 'pump_attendants');
            XLSX.writeFile(wb, 'pump_attendants.xlsx');
         }catch(err){console.log(err)}
      }
   },
   async mounted(){
      utils.registerModule('attendant',attendant,this.$store)
      await this.fetchFormData()
      await this.fetchAttendants()
   }
}
</script>

<style lang="scss">
   .test-form{
      
   }
</style>